import { useDispatch, useSelector } from 'react-redux';
import useImpression from '../../useImpression';
import { IRootState } from '../../../store';
import getFlagValue, { FLAG_ENUM } from '../../../helpers/utils/getFlagValue';
import { addQueueGlobalCount } from '../../../store/emarsys/action';
import { useState } from 'react';

const useImpressionHomepage = (
  firstRef: React.RefObject<HTMLElement>,
  title: string,
  sectionName: string = ''
) => {
  const dispatch = useDispatch();
  const { isLargeScreen } = useSelector((state: IRootState) => state.page) || {
    isLargeScreen: false,
  };
  const { isAuth, userData } = useSelector((state: IRootState) => state.auth) || {
    isAuth: false,
    userData: null,
  };
  const [headerCategoryPushed, setHeaderCategoryPushed] = useState(false);

  useImpression(
    firstRef,
    1,
    () => {
      const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
      const isHomepageActive = getFlagValue(FLAG_ENUM.EMARSYS_HOME_PAGE);
      if (isAuth && isFlagActive && isHomepageActive) {
        const valuePageView: Record<string, string | number | boolean> = {
          page_name: 'homepage',
          page_title: title,
          page_url: window.location.href,
          section_name: sectionName,
        };

        if (userData?.customerNo) {
          ScarabQueue.push(['setCustomerId', userData?.customerNo]);
        }
        if (!headerCategoryPushed && sectionName === 'header category') {
          ScarabQueue.push(['tag', 'impressions', valuePageView]);
          setHeaderCategoryPushed(true);
        } else if (sectionName !== 'header category') {
          ScarabQueue.push(['tag', 'impressions', valuePageView]);
        }

        dispatch(addQueueGlobalCount());
      }
    },
    {
      rootMargin:
        sectionName === 'header category'
          ? ''
          : isLargeScreen
            ? '-112px 0px 0px 0px'
            : '-60px 0px 0px 0px',
    },
    [isAuth],
    sectionName === 'header category' ? 0 : isLargeScreen ? 112 : 60,
    isLargeScreen ? 0 : 0
  );

  return null;
};

export default useImpressionHomepage;
